import React, { useRef } from 'react';
import uniqueId from 'lodash/uniqueId';
import styles from '../StructuredModal.module.scss';
import { TextV2 } from 'components/TextV2/TextV2';

interface TitleAndDescriptionProps {
  title?: string;
  description?: string;
}

export const TitleAndDescription: React.FC<TitleAndDescriptionProps> = ({ title, description }) => {
  const uid = useRef(uniqueId());

  if (!title && !description) return null;

  return (
    <div className={styles.modalContent}>
      {title && (
        <TextV2 tagName="h3" variant="h3-bold" value={title} id={`structured-modal-title-${uid.current}`} />
      )}
      {description && <TextV2 tagName="div" variant="body" value={description} isMarkdown />}
    </div>
  );
};
